import { EScanNetwork, IImpactScanToEarnInfoRespDto } from 'src/types'
import useStyles from './../styles'
import { Box, Link, IconButton, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import { getScanExplorerTxUrl, getTableTimestamp, shortenStringMiddle2 } from 'src/common/utils'
import { LinkIcon } from 'src/assets/icons'
import { useCopy, useMe } from 'src/hooks'

interface IProps {
  items: IImpactScanToEarnInfoRespDto[]
}

export const ImpactScanToEarnSection = ({ items }: IProps) => {
  const classes = useStyles()

  return (
    <div className={classes.bigContainer}>
      <div className={classes.text}>AI Verified</div>
      {/* <div className={classes.textCounter}>
        {items.length} {'items'}
      </div> */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', justifyContent: 'center' }}>
        {items.map((item) => (
          <ImpactScanToEarnItem item={item} />
        ))}
      </Box>
    </div>
  )
}

interface IItemProps {
  item: IImpactScanToEarnInfoRespDto
}

export const ImpactScanToEarnItem = ({ item }: IItemProps) => {
  const { data: me } = useMe()

  const classes = useStyles()
  const theme = useTheme()

  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_l'))

  const handleCopy = useCopy(item.consumerScan.user_tx_decrypted)
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '3px',
        justifyContent: 'start',
      }}
    >
      <Tooltip title={item.consumerScan.user_tx_decrypted}>
        <Typography sx={{ fontSize: '12px' }}>
          {isTablet
            ? shortenStringMiddle2(item.consumerScan.user_tx_decrypted, isMobile ? 11 : 25, '...')
            : item.consumerScan.user_tx_decrypted}
        </Typography>
      </Tooltip>
      <Box sx={{ display: 'flex', gap: isTablet ? '0px' : '3px' }}>
        <IconButton
          disabled={!item.consumerScan.user_tx_decrypted}
          size="small"
          component={Link}
          href={
            item.consumerScan.user_tx_decrypted
              ? getScanExplorerTxUrl(item.consumerScan.user_tx_decrypted, EScanNetwork.BASE)
              : '#'
          }
          target="_blank"
        >
          <LinkIcon className={isTablet ? classes.copyIconSmall : classes.copyIcon} />
        </IconButton>

        <IconButton
          size="small"
          disabled={!item.consumerScan.user_tx_decrypted}
          onClick={handleCopy}
        >
          <ContentCopyIcon className={isTablet ? classes.copyIconSmall : classes.copyIcon} />
        </IconButton>
      </Box>
      <Typography fontSize={'11px'} sx={{ ml: 'auto' }}>
        {getTableTimestamp({ date: item?.consumerScan?.approved_on, timezone: me?.timezone })}
      </Typography>
    </Box>
  )
}
